import request from '_utils/request'

export function listspecial(data) {
    return request({
      url: '/web_api/special/columnWindow/list',
      method: 'post',
      data: data
    })
  }
  export function imgList(data) {
    return request({
      url: '/web_api/special/workWindow/list',
      method: 'post',
      data: data
    })
  }
  export function infospecial(data) {
    return request({
      url: '/web_api/special/columnWindow/'+data,
      method: 'get',
    })
  }